/* eslint-disable react/prop-types */
import { AlertTriangle, DatabaseZap, Settings2 } from 'lucide-react';
import { Button } from 'src/features/tyre-management/components/ui/button';

const copy = {
  stale: { title: 'Data is out of date', icon: DatabaseZap },
  unavailable: { title: 'Data is unavailable', icon: AlertTriangle },
  not_configured: { title: 'Setup is required', icon: Settings2 },
};

const SectionState = ({ section, onRefresh, children }) => {
  if (!section || section.status === 'forbidden') return null;
  if (section.data && ['ready', 'stale', 'not_configured'].includes(section.status)) return children;
  const state = copy[section.status] || copy.unavailable;
  const Icon = state.icon;
  return (
    <div className="flex min-h-[220px] flex-col items-center justify-center rounded-xl border border-dashed border-slate-300 bg-slate-50/70 p-8 text-center" role="status">
      <span className="rounded-full bg-white p-3 text-slate-400 shadow-sm"><Icon className="h-6 w-6" aria-hidden="true" /></span>
      <p className="mt-4 text-base font-bold text-slate-900">{state.title}</p>
      <p className="mt-1 max-w-md text-sm text-slate-500">{section.reason || 'This section could not be loaded.'}</p>
      {onRefresh && <Button className="mt-5" type="button" size="sm" variant="outline" onClick={onRefresh}>Try again</Button>}
    </div>
  );
};

export default SectionState;
